import React from 'react'
import Link from 'gatsby-link'
import Slider from 'react-slick'
import Img from 'gatsby-image'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
}

const IndexPage = ({ data }) => (
  <div style={{ marginLeft: '-1.405rem', marginRight: '-1.405rem' }}>
    <Slider {...settings}>
      <div>
        <Img
          style={{
            height: '30vh',
          }}
          sizes={data.slider1.sizes}
        />
      </div>
      <div>
        <Img
          style={{
            height: '30vh',
          }}
          sizes={data.slider2.sizes}
        />
      </div>
      <div>
        <Img
          style={{
            height: '30vh',
          }}
          sizes={data.slider3.sizes}
        />
      </div>
    </Slider>
  </div>
)

export default IndexPage

export const query = graphql`
  query CarouselImages {
    slider1: imageSharp(id: { regex: "/slider1.jpg/" }) {
      sizes(maxWidth: 960) {
        ...GatsbyImageSharpSizes
      }
    }
    slider2: imageSharp(id: { regex: "/slider2.jpg/" }) {
      sizes(maxWidth: 960) {
        ...GatsbyImageSharpSizes
      }
    }
    slider3: imageSharp(id: { regex: "/slider3.jpg/" }) {
      sizes(maxWidth: 960) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js